export interface BlogPost {
  slug: string;
  title: string;
  date: string; // YYYY-MM-DD
  category: string;
  excerpt: string;
  contentMarkdown: string;
  imageUrl?: string;
  author?: string;
  tags?: string[];
}

export const blogPosts: BlogPost[] = [
  {
    slug: 'how-small-sellers-close-more-high-ticket-sales-with-financing',
    title: 'How Small Sellers Close More High-Ticket Sales with Financing',
    date: '2026-02-10',
    category: 'Sales Strategy',
    author: 'LendLifted Team',
    tags: ['Seller financing', 'Close rate', 'Small business'],
    excerpt:
      'A practical playbook for offering monthly options without adding friction to your sales process.',
    imageUrl:
      'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=2000&auto=format&fit=crop',
    contentMarkdown: `
Bottom line: adding monthly options at checkout can help small sellers close more moderate-to-high ticket deals by lowering upfront payment pressure for buyers.

## Why this works

Most buyers do not reject the product. They pause because the one-time payment feels heavy in the moment.
When you offer financing clearly, the decision shifts from "Can I pay all of this today?" to "Can I afford this monthly?"

## A simple seller workflow

1. Enter the quote amount once.
2. Share one checkout link or QR code.
3. Let the buyer pick the option that fits.
4. Follow up quickly when intent signals appear.

## What to say in the moment

Keep language simple:

- "If helpful, you can split this into monthly payments."
- "I can send one link now so you can review options privately."
- "If you reopen it later, I can answer any questions right away."

## What to measure

Track these first:

- Quote-to-checkout-start rate
- Checkout-start-to-paid rate
- Time from first quote view to payment

When these improve, your financing flow is doing its job.
    `,
  },
  {
    slug: 'qr-and-sms-follow-up-playbook-for-in-person-selling',
    title: 'QR + SMS Follow-Up Playbook for In-Person Selling',
    date: '2026-02-12',
    category: 'Playbooks',
    author: 'LendLifted Team',
    tags: ['QR checkout', 'SMS follow-up', 'In-person sales'],
    excerpt:
      'Use this no-fluff sequence to move buyers from in-person interest to completed financing checkout.',
    imageUrl:
      'https://images.unsplash.com/photo-1556740758-90de374c12ad?q=80&w=2000&auto=format&fit=crop',
    contentMarkdown: `
Bottom line: sellers close faster when they pair an in-person QR handoff with short, helpful SMS follow-up.

## Step 1: hand off checkout while interest is high

Show the QR code on your phone right after you confirm the quote.
This removes delay and gives the buyer a private way to continue.

## Step 2: send one same-day message

Keep it short:

> "Here is your checkout link with monthly options. Happy to answer anything before you decide."

Avoid pressure language. Clarity beats urgency.

## Step 3: send one reminder only if needed

If the buyer viewed but did not complete, send one follow-up within 24 to 48 hours:

> "Quick check-in in case you wanted to move forward today. I can help with any questions."

## Step 4: improve your sequence weekly

Review which channel wins for your team:

- QR in person
- SMS right after visit
- SMS reminder next day

Standardize the best path and keep it simple for every seller on your team.
    `,
  },
];
